import ContainerIconValuesManager from "../../components/ContainerIconValuesManager";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DropdownDateRange from "components/datetime/DropdownDateRange";
import { translations } from "../translations";
import useCustomTranslation from "core/customTranslation";
import { useNavigate, useLocation, Link } from "react-router-dom";

const Paramsitem = ({ item, handleResetZoom, dateRange, setDateRange, lastMeasure }) => {
    const { t: _Tf } = useTranslation("forms");
    const { t: _Tt } = useTranslation("tables");
    const { t: _Tr } = useTranslation("routes");
    const { t: _Tg } = useTranslation("grafics");
    const { t: _tC } = useCustomTranslation(translations);

    const navigate = useNavigate();
    const location = useLocation();

    const styleLabel = {
        maxWidth: "100px",
        display: "flex",
        alignItems: "center",
        justifyContent: "end",
    };
    const styleValue = {
        fontSize: "1.1rem",
        fontWeight: "400",
    };
    return (
        <>
            <div className="row">
                <div className="col-md col-12">
                    <div className="row">
                        <div className="col-12 mb-2">
                            <div className="row mb-2">
                                <div className="col small text-secondary" style={styleLabel}>
                                    {_Tf("container.address")}:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.address}, {item.number}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    {_Tf("container.city")}:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.codpost}-{item.municipality}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    {_Tf("container.province")}:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.province}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    {_Tf("container.country")}:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.country}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    {_Tg("headers.containers.distance")}:
                                </div>
                                <div className="col" style={styleValue}>
                                    {lastMeasure ? lastMeasure : 0} cm
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="col-md col-12" style={{ minWidth: "268px" }}>
                    <div className="col asset-icon-measures p-2">
                        <ContainerIconValuesManager item={item} lastMeasure={lastMeasure} />
                    </div>
                </div>
            </div>
            <div className="row d-flex w-full">
                {item.has_device ? (
                    <div className="col-12 d-flex justify-content-center mt-5">
                        {!location.pathname.includes("/unloads/") && (
                            <button className="btn btn-sm btn-outline-primary me-3" onClick={handleResetZoom}>
                                <FontAwesomeIcon icon="rotate-right" /> Zoom
                            </button>
                        )}

                        <div style={{ display: "inline-block", minWidth: "200px" }}>
                            <DropdownDateRange size="sm" dateRange={dateRange} setDateRange={setDateRange} maxDays={30} />
                        </div>
                    </div>
                ) : (
                    <div className="alert alert-secondary text-center mt-4">{_tC("no.devices")}</div>
                )}
            </div>
        </>
    );
};
export default Paramsitem;
